<template>
    <a v-if="!dontShowIn.includes($route.path)" href="https://wa.link/2icsee" target="_blank">
        <div class="contacto-flotante">
            <img src="@/assets/icon-whatsapp-white.svg" alt="" class="">
        </div>    
    </a>
</template>
<script>
export default {
    name: 'ContactoFlotante',
    data() {
        return {
            dontShowIn: [
                '/pagar',
                '/pagar/prontopago',
                '/pagar/metodo-pago',
                '/pagar/metodo-pago/pse',
                '/pagar/metodo-pago/tc',
                '/pagar/metodo-pago/efecty',
            ]
        }
    }
}
</script>
<style lang="scss">
.contacto-flotante{
    background-color: #00b66c;
    position: fixed;
    z-index: 200;
    right: 20px;
    bottom: 75px;
    border-radius: 50%;
    padding: 1rem;
    cursor: pointer;
    box-shadow: 0px 0px 17px 0px #adadad;
    img{
        filter: grayscale(1);
        width: 28px;
    }
    &:hover{
        opacity: .8;
    }
}
</style>